import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { TopLevelErrorBoundary } from '@/components/RootErrorBoundary'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <TopLevelErrorBoundary>
      <App />
    </TopLevelErrorBoundary>
  </StrictMode>,
)
